import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons } from '@fluentui/react'

import Chat from './pages/chat/Chat'
import Admin from './pages/admin/Admin'
import Layout from './pages/layout/Layout'
import NoPage from './pages/NoPage'
import { AppStateProvider } from './state/AppProvider'

import './index.css'
import LitReview from './pages/litReview/LitReview'

import { initializeMsal } from './auth/auth'
import { BrowserRouter } from "react-router-dom"

initializeIcons(
  'https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/',
);

export default function App() {
  return (
    <AppStateProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Chat />} />
            <Route path="c/:conversation_id" element={<Chat />} /> {/* New route */}
            <Route path="*" element={<NoPage />} />
            <Route path="c/:conversation_id" element={<Chat />} /> {/* New route */}
            <Route path="/admin" element={<Admin />} />
            <Route path="c/:conversation_id" element={<Chat />} /> {/* New route */}
            <Route path="/litreview" element = {<LitReview/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </AppStateProvider>
  )
}

async function startApp() {
  await initializeMsal()

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

startApp()
